exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-detencion[data-v-b27ed6a6] {\n  margin-left: 5px;\n  width: 90px;\n  margin-right: 15px;\n  padding-right: 5px;\n}\n.divClassLabel[data-v-b27ed6a6] {\n  margin-right: 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports
